module.exports = "images/okoo_to_francetv.08801f7b.png";